<template>
    <b-card-group>
        <div
        :style="{ backgroundColor: backgroundColor }"
            class="container mb-5 searchCard">
            <div class="row"
                :style="{ backgroundColor: headerColor }">
                <div class="col mt-2">
                    <h4 v-if="section.headerText"
                      class="text-white">{{section.headerText}}</h4>
                    <p class="text-white">
                        <span
                          :style="{ backgroundColor:
                              !section.subHeaderText ? headerColor : subHeaderColor }"
                          class="styleLabel">{{section.subHeaderText.toUpperCase()}}</span>
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col mt-2 mb-2">
                    <div>
                        <li
                            :key="`items-${index}`"
                            v-for="(item, index) in section.items"
                            >{{item}}
                        </li>
                    </div>
                </div>
            </div>
        </div>
    </b-card-group>
</template>
<script>
import {
  BCardGroup,
} from 'bootstrap-vue';

export default {
  components: {
    BCardGroup,
  },
  props: {
    subHeaderColor: {
      required: true,
      type: String,
    },
    headerColor: {
      required: true,
      type: String,
    },
    backgroundColor: {
      required: true,
      type: String,
    },
    section: {
      default: () => [],
      required: true,
      type: Array,
    },
  },
};
</script>
<style scoped>
.searchCard {
    border: #003a63 solid 1px;
}
.styleLabel {
  color: white;
  padding: 5px;
  font-weight: bold;
}
</style>
